import React from 'react'
import { Link } from 'react-router-dom'

import {
  Box,
  Divider,
  Drawer as MUIDrawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from '@mui/material'

import Logo from '~/assets/images/logo/logo.png'
import { routeNames } from '~/constants/uiRouteNames'
import useStoreState from '~/hooks/useStoreState'

import DarkModeToggle from './DarkModeToggle'
import { contactItems, legalItems } from './Footer'
import { headerItems } from './Header'
import L from './Helpers/Lang'
import { tabList as userTabList } from './Pages/Account/AccountTabs'
import { tabList as adminTabList } from './Pages/Admin/AdminTabs'

const Drawer = (props) => {
  const auth = useStoreState('auth')

  return (
    <MUIDrawer ModalProps={{ keepMounted: true }} {...props}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        maxWidth={256}
        onClick={props.onClose}
      >
        <Link to={routeNames.root}>
          <Box
            component="img"
            sx={(theme) => ({
              width: 150,
              ...(theme.palette.mode === 'dark'
                ? { filter: 'invert(100%)' }
                : undefined),
              m: 2,
            })}
            src={Logo}
          />
        </Link>

        <Divider />

        <List>
          {headerItems.map((hi) => (
            <ListItem key={hi.id} disablePadding>
              <ListItemButton href={hi.url}>
                <ListItemIcon>{hi.icon}</ListItemIcon>
                <ListItemText primary={hi.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {auth.user?.admin && (
          <>
            <Divider />
            <List
              subheader={
                <ListSubheader disableSticky sx={{ background: 'inherit' }}>
                  <L>nav.admin</L>
                </ListSubheader>
              }
            >
              {adminTabList.map((tab) => (
                <ListItem key={tab.name} disablePadding>
                  <ListItemButton href={tab.link}>
                    <ListItemIcon>{tab.icon}</ListItemIcon>
                    <ListItemText primary={<L>{tab.label}</L>} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </>
        )}

        {auth.isSignedIn && (
          <>
            <Divider />
            <List
              subheader={
                <ListSubheader disableSticky sx={{ background: 'inherit' }}>
                  <L>nav.account</L>
                </ListSubheader>
              }
            >
              {userTabList.map((tab) => (
                <ListItem key={tab.name} disablePadding>
                  <ListItemButton href={tab.link}>
                    <ListItemIcon>{tab.icon}</ListItemIcon>
                    <ListItemText primary={<L>{tab.label}</L>} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </>
        )}

        <Box flex={1} />

        <List
          subheader={
            <ListSubheader disableSticky sx={{ background: 'inherit' }}>
              <L>title.contact</L>
            </ListSubheader>
          }
        >
          {contactItems.map((ci) => (
            <ListItem key={ci.id} disablePadding>
              <ListItemButton href={ci.url}>
                <ListItemIcon>{ci.icon}</ListItemIcon>
                <ListItemText primary={ci.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider />

        <List
          subheader={
            <ListSubheader disableSticky sx={{ background: 'inherit' }}>
              <L>title.legal</L>
            </ListSubheader>
          }
        >
          {legalItems.map((li) => (
            <ListItem key={li.id} disablePadding>
              <ListItemButton href={li.url}>
                <ListItemIcon>{li.icon}</ListItemIcon>
                <ListItemText primary={li.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider />

        <DarkModeToggle style={{ marginTop: '10px', marginLeft: '10px' }} />
      </Box>
    </MUIDrawer>
  )
}

export default Drawer
